<div class="flex flex-col h-svh items-center justify-center gap-6">
  @if (bank) {
    @if (bank.value.logo) {
      <img
        class="h-20 w-20 rounded-full object-cover"
        [src]="bank.value.logo.value"
        [alt]="bank.value.name"
      />
    } @else {
      <p class="text-secondary font-bold text-base">{{ bank.value.name }}</p>
    }
  }
  <img src="../../../assets/svg/loader.svg" alt="loader" />
  <p class="text-center px-6">{{ 'bank_authentication_portail_is_loading' | translate }}</p>
</div>
